import serverData from './server-data'

const hasTreatmentName = (name) => {
	const { elmoFlags: { elmo = {} } = {} } = serverData;
	const { treatments = [] } = elmo;
	if (!treatments.length) {
		return false
	}
	const nameToCheck = name.toLowerCase()
	return treatments.findIndex(({ treatment_name }) => treatment_name.toLowerCase() === nameToCheck) !== -1
}

export const getTreatmentDataByName = (name) => {
	const { elmoFlags: { elmo = {} } = {} } = serverData;
	const { treatments = [] } = elmo;
	if (!treatments.length) {
		return false
	}
	const treatmentItem = treatments.find((item) => {
		return item.treatment_name === name;
	});
	return treatmentItem;
}

export default hasTreatmentName
